import { render, staticRenderFns } from "./StockCastana.vue?vue&type=template&id=1848909a&"
import script from "./StockCastana.vue?vue&type=script&lang=js&"
export * from "./StockCastana.vue?vue&type=script&lang=js&"
import style0 from "./StockCastana.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports